import { useMediaQuery } from "@mui/material";

export const useIsMobilePortraitScreen = () => {
  const isPortrait = useMediaQuery("(orientation: portrait)");
  const isSmallScreen = useMediaQuery("(max-device-width: 800px)");

  return isPortrait || isSmallScreen;
};
